import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';

const Message = styled.div`
  margin: ${tokens.size_spacing_s}px 0;
  font-size: ${tokens.size_text_s}px;
  line-height: ${tokens.size_text_s + 4}px;
  color: ${(props) =>
    props.variant === 'helper'
      ? tokens.color_text_subtle_le
      : tokens.color_utility_destroy};
`;

const FormMessage = ({ children, variant }) => {
  return <Message variant={variant}>{children}</Message>;
};

FormMessage.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['error', 'helper']),
};

FormMessage.defaultProps = {
  children: null,
  variant: 'error',
};

export default FormMessage;
